import { Component, Vue } from 'vue-property-decorator';
import './main-content.component.scss';
import { Breadcrumb } from '@/common/model/breadcrumb.model';
import BreadcrumbComponent from '@/common/components/breadcrumb/breadcrumb.component';
import { namespace } from 'vuex-class';
import AlertMessageComponent from '@/common/components/alert-message/alert-message.component';
import store from '@/common/store/index';
import AppConstants from '@/common/constants/app.constants';
import NumberUtils from '../utils/number.util';
import DetailMessageModal from '../components/detail-message-modal/detail-message-modal';

const AlertMessageStore = namespace('AlertMessageStore');
@Component
export default class MainContentComponent extends Vue {
  @AlertMessageStore.Getter
  errorMessageArray!: Array<string>;

  @AlertMessageStore.Getter
  successMessageArray!: Array<string>;

  workMode = NumberUtils.parseInt(localStorage.getItem(AppConstants.STORAGE_WORK_MODE));
  get breadcrumbs() {
    let breadcrumbLink = '';
    const pathArray = this.$route.path.split('/');
    pathArray.shift();
    const breadcrumbPath = pathArray
      .filter((path) => !!path)
      .reduce((breadcrumbArray, path, idx) => {
        const excludedFromBreadcrumb = this.$route.matched[idx]?.meta.excludedFromBreadcrumb;
        if (!excludedFromBreadcrumb) {
          breadcrumbLink += breadcrumbArray[idx - 1] ? breadcrumbArray[idx - 1].link + '/' + path : '/' + path;
          breadcrumbArray.push({
            link: breadcrumbLink,
            text: this.$route.matched[idx]?.meta.breadCrumb,
            icon: this.$route.matched[idx]?.meta.icon,
            parentText1: this.$route.matched[idx]?.meta.parentText1,
            parentText2: this.$route.matched[idx]?.meta.parentText2
          });
          breadcrumbLink = '';
        } else {
          breadcrumbLink += breadcrumbArray[idx - 1] ? breadcrumbArray[idx - 1].link + '/' + path : '/' + path;
        }
        return breadcrumbArray;
      }, new Array<Breadcrumb>());
    return breadcrumbPath;
  }

  get hideBreadcrumb() {
    return this.$route?.meta?.hideBreadcrumb;
  }

  get noFooter() {
    return this.$route?.meta?.noFooter;
  }

  get displayBtnSetting() {
    return this.$route?.meta?.displayBtnSetting;
  }

  render() {
    return (
      <div v-frag>
        <div class="row bg-white py-4 border-bottom border-2 mx-auto justify-content-between ">
          <div class="col ml-4">
            {!this.hideBreadcrumb && (
              <div v-frag>
                <BreadcrumbComponent breadcrumbs={this.breadcrumbs} />
              </div>
            )}
          </div>
        </div>
        {store.getters.getModalMode ? null : <AlertMessageComponent />}
        <div
          class={{
            'container-fluid screen-body flex-column justify-content-center align-items-center: ':
              this.workMode === AppConstants.WORK_MODE_T_SORT
          }}
          style={{
            height: `calc(${100}vh - ${this.calculateCommonSectionsHeight}px)`
          }}
        >
          <router-view></router-view>
        </div>
        <DetailMessageModal
          title="詳細メッセージ"
          idModal={AppConstants.DETAIL_ERROR_MESSAGE_ID_MODAL}
          errorMsg={this.errorMessageArray[0] || ''}
        />
      </div>
    );
  }

  get calculateCommonSectionsHeight() {
    // commonSectionsHeight = 68px (header) + 125px (breadcrumb)
    let commonSectionsHeight = 68 + 125;

    // (+ 90px if any footer)
    if (!this.noFooter) {
      commonSectionsHeight += 90;
    }

    // (+ 60px if the setting button is displayed)
    if (this.displayBtnSetting) {
      commonSectionsHeight += 60;
    }
    // return if modal modal = true
    if (store.getters.getModalMode) {
      return commonSectionsHeight;
    }

    // (+50px if any error message) or (+ 50px if any success message)
    if (this.errorMessageArray.length > 0 || this.successMessageArray.length > 0) {
      //+3 if any message(margin alert message)
      commonSectionsHeight += 3;
      // (+98px if any error message and success message)
      commonSectionsHeight +=
        this.errorMessageArray.length > 0 && this.successMessageArray.length > 0 ? 50 * 2 - 2 : 50;
    }

    return commonSectionsHeight;
  }

  isTopPage() {
    return this.$route.name === 'TOP';
  }

  onClickBreadcrumb(e: Event, breadcrumb: Breadcrumb) {
    e.preventDefault();
    this.$router.push(breadcrumb.link);
  }
}
